// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"881":"1317c827","1573":"1317c827","1691":"9ff32c56","2778":"1317c827","4230":"1317c827","8097":"1317c827","8406":"9ff32c56","9877":"1317c827"}[chunkId] + ".chunk.css";
};